/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Text from "./Text";

const StyledDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: rgba(${({ theme }) => theme.colors.border.rgba});
  }
`;

const PlainRule = styled.div`
  height: 1px;
  background: rgba(${({ theme }) => theme.colors.border.rgba});
`;

const Divider = ({ label, ...props }) => {
  if (!label) {
    return <PlainRule {...props} />;
  }

  return (
    <StyledDivider {...props}>
      <Text>{label}</Text>
    </StyledDivider>
  );
};

export default Divider;
